/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */
import Splide from '@splidejs/splide';
import {AutoScroll} from '@splidejs/splide-extension-auto-scroll';
( function( app ) {
  const COMPONENT = {
    init: function() {
      $( '.navbar .dropdown-trigger' ).on( 'toggleAfter', ( event ) => {
        $( '.navbar .product-card' ).each( function( key, card ) {
          $( card ).find( '.product-card__slider.has-slides' ).slick( 'unslick' );
          $( card ).find( '.product-card__slider.has-slides' ).slick( {
            arrows: true,
            dots: false,
            slidesToShow: 1,
            prevArrow: $( card ).find( '.prev-slide' )[0],
            nextArrow: $( card ).find( '.next-slide' )[0],
          } );
        } );
      } );

      const lastScrollTop = 0;
      window.addEventListener( 'scroll', function() {
        const st = window.pageYOffset || document.documentElement.scrollTop;
        if ( st > 0 ) {
          $( '.navbar.has-marquee' ).addClass( 'is-scrolled' );
        } else {
          $( '.navbar.has-marquee' ).removeClass( 'is-scrolled' );
        }
      }, false );

      $( '.js-init-video' ).magnificPopup( {
        type: 'iframe',
        mainClass: 'mfp-fade',
        removalDelay: 160,
        preloader: false,
        fixedContentPos: false,
        callbacks: {
          open: function() {
            $( 'video' ).trigger( 'pause' );
          },
          close: function() {
            $( 'video' ).trigger( 'play' );
          },
        },
      } );

      $( '.js-init-content' ).magnificPopup( {
        type: 'inline',
        mainClass: 'mfp-fade',
        removalDelay: 160,
        preloader: false,
        fixedContentPos: false,
      } );

      $( '.woocommerce-product-gallery__wrapper' ).magnificPopup( {
        delegate: 'a',
        type: 'image',
        tLoading: 'Loading image #%curr%...',
        mainClass: 'mfp-img-mobile',
        gallery: {
          enabled: true,
          navigateByImgClick: true,
          preload: [0, 1], // Will preload 0 - before current, and 1 after the current image
        },
      } );

      $( document ).on( 'updateMediaQuery', ( event ) => {
        /*
         * Remove any inline display values when the screen changes
         * between mobile and desktop state. This allows the default
         * stylings to kick in and prevent any weird "half mobile half desktop"
         * nav display states that sometimes occur while resizing the browser
         * Also remove any active is-open classes from the toggle and nav to reset
         * its state when switching between screen sizes
         */
        $( '.primary-nav' ).get( 0 ).style.removeProperty( 'display' );
        $( '.navbar-toggle, .primary-nav' ).removeClass( 'is-open' );
      } );

      // Nav marquee
      if ( $( '.splide--nav-marquee' ).length ) {
        new Splide( '.splide--nav-marquee', {
          type: 'loop',
          autoWidth: true,
          autoScroll: {
            speed: 0.75,
          },
        } ).mount( {AutoScroll} );
      }

      // $( '.btn, .nav-btn, .form-skin button[type="submit"], .woocommerce #respond input#submit.alt, .woocommerce a.button.alt, .woocommerce button.button.alt, .woocommerce input.button.alt, .woocommerce #respond input#submit, .woocommerce a.button, .woocommerce button.button, .woocommerce input.button' ).each( function( index, button ) {
      //   $( button ).attr( 'data-text', $( button ).text() ).wrapInner( '<span></span>' );
      // } );

      $( document ).on( 'mouseleave', function() {
        if ( $( 'body' ).find( '.cc-exit-intent' ).length > 0 ) {
          if ( !localStorage.getItem( 'cc_leaving_popup_seen_' + $( 'body' ).find( '.cc-exit-intent' ).attr( 'data-id' ) ) ) {
            $.magnificPopup.open( {
              items: {
                src: '#cc-exit-intent',
              },
              type: 'inline',
              mainClass: 'mfp-fade',
              removalDelay: 160,
              preloader: false,
              fixedContentPos: false,
            } );

            localStorage.setItem( 'cc_leaving_popup_seen_' + $( 'body' ).find( '.cc-exit-intent' ).attr( 'data-id' ), true );
          }
        }
      } );

      $( '.cc-exit-intent__close' ).on( 'click', function() {
        $.magnificPopup.close();
      } );

      $( document ).on( 'gform_confirmation_loaded', function( event, formId ) {
        console.log( formId );
        console.log( $( '.cc-exit-intent .form-skin' ).attr( 'id' ).replace( 'gform_confirmation_wrapper_', '' ) );
        if ( formId == $( '.cc-exit-intent .form-skin' ).attr( 'id' ).replace( 'gform_confirmation_wrapper_', '' ) ) {
          $( '.cc-exit-intent .cc-exit-intent__close' ).hide();
        }
      } );

      $( '.cc-stars-selection button' ).on( 'click', function() {
        $( '.cc-stars-selection button' ).not( this ).removeClass( 'is-selected' );
        $( this ).addClass( 'is-selected' );
        $( this ).closest( '.cc-stars-selection' ).addClass( 'is-selected' );

        $( 'select#rating option:not([value=' + $( this ).attr( 'data-value' ) + '])' ).attr( 'selected', false );
        $( 'select#rating option[value=' + $( this ).attr( 'data-value' ) + ']' ).attr( 'selected', true );
      } );

      $( '.single_variation_wrap' ).on( 'show_variation', function( event, variation ) {
        $( '.woocommerce div.product p.price' ).addClass( 'invisible' );
        $( '.woocommerce-variation-price .woocommerce-Price-amount' ).removeClass( 'invisible' );

        if ( variation.attributes['attribute_pa_size'] == '5-lbs' ) {
          $( '.single_variation_wrap' ).addClass( 'is-best-value' );
        } else {
          $( '.single_variation_wrap' ).removeClass( 'is-best-value' );
        }
      } );

      $( '.woocommerce div.product form.cart .reset_variations' ).on( 'click', function() {
        $( '.woocommerce div.product p.price' ).removeClass( 'invisible' );
        $( '.woocommerce-variation-price .woocommerce-Price-amount' ).addClass( 'invisible' );
      } );

      // if actual is the same as new, set price as the actual value
      $( '.wwp-wholesale-pricing-details' ).each( function() {
        if ( $( this ).find( 'p:nth-child(1) bdi' ).text() == $( this ).find( 'p:nth-child(2) bdi' ).text() ) {
          $( this ).prev().html( $( this ).find( 'p:nth-child(1) .woocommerce-Price-amount.amount' ).html() );
          $( this ).hide();
        }
      } );

      // Check the "Copy from billing address" input by default
      setTimeout( function() {
        if ( $( '.wwp_wholesaler_registration_form' ).length ) {
          $( '#wwp_wholesaler_copy_billing_address' ).trigger( 'click' );
        }
      }, 1000 );

      $( '.wcsatt-options input' ).on( 'change', function() {
        setTimeout( function() {
          $( 'button[type="submit"][name="update_cart"]' ).trigger( 'click' );
        }, 300 );
      } );
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'common', COMPONENT );
} )( app );
